import { combineReducers } from 'redux';
import { Set, Map } from 'immutable';
import { serializeManip } from './manip';
import {
  FETCH_MANIPS,
  FETCH_MANIPS_SUCCESS,
  CREATE_MANIP,
  UPDATE_MANIP,
  DELETE_MANIP,
} from '../actions/manips';

const byId = (state = {}, action) => {
  if (action.response) {
    return {
      ...state,
      ...action.response.entities.manipulations,
    };
  }

  return state;
};

const allIds = (state = [], action) => {
  switch (action.type) {
    case FETCH_MANIPS_SUCCESS:
      return action.response.result;
    case CREATE_MANIP:
      return [...state, action.response.result];
    case UPDATE_MANIP: {
      var existing = state.find(m => action.response.result === m);
      if (existing !== undefined) {
        var index = state.indexOf(existing);
        state[index] = action.response.result;
      } else {
        return [...state, action.response.result];
      }
    }
    default:
      return state;
  }
};

const deletedIds = (state = [], action) => {
  switch (action.type) {
    case DELETE_MANIP:
      return [...state, action.manip.id];
    default:
      return state;
  }
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case FETCH_MANIPS:
      return true;
    case FETCH_MANIPS_SUCCESS:
      return false;
    default:
      return state;
  }
};

const manips = combineReducers({
  byId,
  allIds,
  deletedIds,
  isFetching,
});

export default manips;

export const getIsFetching = state => state.manips.manips.isFetching;

const getAllManips = state =>
  state.manips.manips.allIds.map(id => state.manips.manips.byId[id]);

export const getCreatedManips = state => {
  const allManips = getAllManips(state);
  const deleted = state.manips.manips.deletedIds;

  return allManips
    .filter(m => m.new)
    .filter(m => deleted.indexOf(m.id) === -1)
    .map(serializeManip);
};

export const getUpdatedManips = state => {
  const allManips = getAllManips(state);
  const updated = allManips.filter(m => !m.new).map(serializeManip);

  // Group them by id
  const byId = updated.reduce((map, item) => map.set(item.id, item), Map());
  return byId.toObject();
};

export const getDeletedManips = state => {
  return state.manips.manips.deletedIds
    .map(id => state.manips.manips.byId[id])
    .filter(m => !m.new)
    .map(m => m.id);
};

const getNotDeletedManips = state => {
  const allManips = state.manips.manips.allIds;
  const deletedManips = state.manips.manips.deletedIds;

  return Set(allManips)
    .subtract(deletedManips)
    .map(id => state.manips.manips.byId[id]);
};

export const getManipsByZone = (state, zone) => {
  const manips = getNotDeletedManips(state);
  return manips
    .filter(m => m.zone_id.toString() === zone.toString())
    .sortBy(m => m.number)
    .toArray();
};

export const getManipState = state => {
  const allManips = state.manips.manips.allIds.map(
    id => state.manips.manips.byId[id]
  );

  const preInstallManipCount = allManips.filter(m => m.manip_id === 146).length;
  const normalManipCount = allManips.filter(
    m => m.manip_id && m.manip_id !== 146
  ).length;

  if (preInstallManipCount > 0) {
    return 'study';
  } else if (normalManipCount > 0) {
    return 'intervention';
  } else {
    return 'unknown';
  }
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/reducers/manips.js